import { usePage } from "@inertiajs/vue3";

export const getToken = () => usePage()?.props?.auth?.token;